export class UnProcessableEntity extends Error {
  constructor(code?: string) {
    super('unable to process present instructions');
    this.name = 'unable to process present instructions';
    this.message = code ?? '';
  }
}
